import React from 'react';
import { FadeIn, Section } from './ui';
import { Zap, ShieldCheck, Brain } from 'lucide-react';
export function PromiseSection() {
  const benefits = [{
    icon: <Zap className="text-brand-green" size={32} data-id="element-211" />,
    title: 'Clases listas en 15 min',
    desc: 'Ideas de apertura y cierres que consolidan el aprendizaje. Todo diseñado para que no improvises nada.'
  }, {
    icon: <ShieldCheck className="text-brand-blue" size={32} data-id="element-212" />,
    title: 'Notas reales',
    desc: 'Rúbricas técnicas que ningún padre puede cuestionar. Exámenes que no se pueden resolver con ChatGPT ni PhotoMath.'
  }, {
    icon: <Brain className="text-brand-gold" size={32} data-id="element-213" />,
    title: 'Alumnos que prestan atención',
    desc: 'El método para capturar la atención de una generación distraída en los primeros 10 minutos. Sin gritar. Sin suplicar.'
  }];
  return <Section variant="dark" data-id="element-214">
      <FadeIn data-id="element-215">
        <h2 className="text-[28px] md:text-4xl font-black text-gray-900 mb-4 leading-tight text-center" data-id="element-216">
          Matemática 360 es el sistema que te devuelve el domingo.
        </h2>
        <p className="text-lg md:text-xl text-gray-600 text-center mb-12 max-w-[500px] mx-auto" data-id="element-217">
          No son ideas bonitas. Son plantillas y protocolos listos para ejecutar
          desde mañana.
        </p>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 max-w-[900px] mx-auto" data-id="element-218">
        {benefits.map((benefit, index) => <FadeIn key={index} delay={index * 0.2} className="h-full" data-id="element-219">
            <div className="bg-gray-50 p-6 rounded-2xl border border-gray-200 h-full flex flex-col items-center text-center hover:-translate-y-1 transition-transform duration-300 shadow-sm" data-id="element-220">
              <div className="w-16 h-16 rounded-full bg-white flex items-center justify-center mb-4 shadow-sm border border-gray-100" data-id="element-221">
                {benefit.icon}
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-222">
                {benefit.title}
              </h3>
              <p className="text-gray-600 text-sm md:text-base leading-relaxed" data-id="element-223">
                {benefit.desc}
              </p>
            </div>
          </FadeIn>)}
      </div>
    </Section>;
}